export default __webpack_public_path__ + "static/media/pdf-L2.f1d7a6d1.pdf";